export const BackendURI = {
     uri: 'https://fire-flask-react-wwyg3aukeq-wl.a.run.app',
     // uri: 'http://localhost:8080',
  }
